// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-toggle-buttons";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import BaoDialog from "./../../factories/bao-dialog";
import MessageBus, { IMessageBusEventHandler } from "./../../services/message-bus";
import UserQuickStartModuleDialog from "../bao-dialog/user-quick-start-module-dialog";
class QuickStartModuleViewModel {
    Modules = ko.observableArray([]);
    LargeQuickModuleIconStyle = "dashboard-icons";
    SmallQuickModuleIconStyle = "dashboard-icons-small";
    QuickModuleIconStyle: KnockoutObservable<string> = ko.observable("dashboard-icons");
    ToggleQuickModuleIconStyle: KnockoutObservable<boolean> = ko.observable(true);
    ToggleButtons = ko.observableArray([
        { value: '<i class="fal fa-th-large"></i>', css: "btn-primary",long:"" },
        { value: '<i class="fal fa-th"></i>', css: "btn-primary", long: "" }
    ]);
    constructor(parent) {
        this.TabPage = parent.TabPage;
        this._parent = parent;
        parent.Refresh = () => {
            var def = $.Deferred();
            def.resolve();
            return def.promise();
        };
        this.ToggleQuickModuleIconStyle.subscribe((newValue) => {
            if (newValue) {
                this.QuickModuleIconStyle(this.LargeQuickModuleIconStyle);
                this.SetNewQuickStartModuleToggleState(newValue);
            }
            else {
                this.QuickModuleIconStyle(this.SmallQuickModuleIconStyle);
                this.SetNewQuickStartModuleToggleState(newValue);
            }
        });
        this.Initialized.subscribe(() => {
            if (this.Initialized()) {
                this.InitQuickStartModuleCounters();
            }
        });
    }
    Bao = Bao;
    TabPage: TabPage;
    private _parent: any;
    Initialized = ko.observable(false);
    init() {
        Bao.bindEvent('QuickStartModules:refresh', (value) => this.LoadQuickStartModules());
        this.LoadQuickStartModules();
        return Bao.post("StartModule/GetUserProfile").then((result) => {
            this.ToggleQuickModuleIconStyle(result);
        });
    }
    ;
    LoadQuickStartModules() {
        Bao.post("StartModule/GetQuickStartModules").then((result) => {
            this.Modules(result.map(r => {
                r["TotalNotificationIndicator"] = ko.observable<number>(null);
                r["IsExternalLink"] = this.isExternalLink(r.Url);
                return r;
            }));
            this.Initialized(true);
        });
    }

    private isExternalLink = (url) => {
        try {
            let fullUrl = new URL(url, window.location.href);
            return (this.getBasePath(window.location) !== this.getBasePath(fullUrl))
        } catch (e) {
            return false;
        }
    };

    private getBasePath = (url) => {
        return url.origin + url.pathname.substring(0, url.pathname.lastIndexOf('/') + 1);
    }

    InitQuickStartModuleCounters() {
        this.getModuleCounterViewModels().done(moduleCounterViewModels => {
            if (moduleCounterViewModels.length > 0) {
                this.subscribeModulesToMessageBus(moduleCounterViewModels);
            }
        });
    }
    ;
    loaded() {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    }
    ;
    SetNewQuickStartModuleToggleState(newValue: any) {
        return Bao.post("StartModule/SetUserProfile", JSON.stringify({ toggleState: newValue })).then((result) => {
        });
    }
    ;
    OpenManagementFavoriteDialog = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/ManagementFavoriteDialog")
            .done(result => {
            let dialog = new BaoDialog(Bao.Session.GetMessage("msgManagementFavoriteDialog"), result.Template);
            dialog.Width("600px");
            dialog.ViewModel(new UserQuickStartModuleDialog(dialog));
            dialog.Buttons([
                new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgSave"), () => {
                    var model = (<UserQuickStartModuleDialog>dialog.ViewModel());
                    var requestParameters = {
                        ids: model.IdsToRemove
                    };
                    if (requestParameters.ids.length > 0) {
                        this.TabPage.IsLoading(true);
                        Bao.post("StartModule/RemoveCollectionQuickStartModuleById", JSON.stringify(requestParameters)).then(() => {
                            this.TabPage.IsLoading(false);
                        }).done(() => {
                            Bao.raiseEvent('QuickStartModules:refresh', null);
                            Bao.raiseEvent('FavoriteIcon:refresh', null);
                        });
                    }
                    dialog.Close();
                }),
                new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                    dialog.Close();
                })
            ]);
            dialog.Open();
            this.TabPage.IsLoading(false);
        });
    };
    private getModuleCounterViewModels(): JQueryPromise<any[]> {
        let resultDeferred: JQueryDeferred<any[]> = $.Deferred<any[]>();
        let requireDeferreds: JQueryDeferred<void>[] = [];
        let moduleCounterViewModels = [];
        this.Modules().forEach(m => {
            if (m.ScriptUrl) {
                let requireDeferred: JQueryDeferred<void> = $.Deferred<void>();
                requireDeferreds.push(requireDeferred);
                window.baorequire([m.ScriptUrl], (ViewModel: any) => {
                    let counterViewModel: Interfaces.IQuickStartModuleCounter = new ViewModel();
                    if (counterViewModel.QuickStartModuleCounterMessageBusEventName || counterViewModel.QuickStartModuleCounterGetValueUrl) {
                        moduleCounterViewModels.push({
                            moduleId: m.Id,
                            messageBusEventName: counterViewModel.QuickStartModuleCounterMessageBusEventName,
                            getValueUrl: counterViewModel.QuickStartModuleCounterGetValueUrl
                        });
                    }
                    requireDeferred.resolve();
                }, (viewModelLoadError) => {
                    console.error(viewModelLoadError);
                    requireDeferred.resolve();
                });
            }
        });
        $.when.apply($, requireDeferreds).done(() => resultDeferred.resolve(moduleCounterViewModels));
        return resultDeferred.promise();
    }
    private subscribeModulesToMessageBus(moduleCounterViewModels: any[]) {
        let moduleCounterEventHandlers: IMessageBusEventHandler[] = moduleCounterViewModels.map(m => ({
            name: m.messageBusEventName,
            handler: (count: number) => { this.updateModuleCounter(m.moduleId, count); }
        }));
        MessageBus.subscribe(moduleCounterEventHandlers).finally(() => {
            moduleCounterViewModels.forEach(m => {
                Bao.post(m.getValueUrl).then((count: number) => { this.updateModuleCounter(m.moduleId, count); });
            });
        }).catch((data) => {
            console.warn('Cannot connect to MessageBus. Error: ' + data);
        });
    }
    private updateModuleCounter(moduleId: string, count: number) {
        if (count != null) {
            let module: any = this.Modules().filter(c => c.Id === moduleId)[0];
            if (module != null) {
                module.TotalNotificationIndicator(count);
            }
        }
    }
}
export default QuickStartModuleViewModel;